import ProposalStatusPill from './ProposalStatusPill';
export default ProposalStatusPill;